import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injector } from '@angular/core';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';
import { WaHelperService } from '../../../library/wa-services/wa-helper-service';
import { CountryNameItem } from '../../../library/fetching/types/country-name.item';

/**
 * Interface for Country type
 *
 * @interface ICountryEntitity
 */
interface ICountryEntitity {
  NOC: string;
  CName: string;
  CShort: string;
}

/**
 * Entity dependency for country store
 *
 * @export
 * @class CountryDependencyEntityStore
 * @extends {EntitiesStore<ICountryEntitity>}
 */
export class CountryDependencyEntityStore extends EntitiesStore<ICountryEntitity>{
  constructor(http:HttpClient, private injector:Injector){
    super('COUNTRIES', http);
  }
  /**
   * @Override due to required mapping
   * The method for request data
   *
   * @param {ParamsType} params
   * @param {boolean} request_more
   * @memberof EntitiesStore
   */
  protected getRequest(params: any, request_more: boolean) {
    this.loadingRef = true;
    this.requestMore = request_more;
    return this.http.get<{ pageInfo: any, items: Array<ICountryEntitity> }>(environment.api_url,
      {
        params: new HttpParams({ fromObject: params as any })
          .append('content', this.endpoint_name)
          .append('v', '3')
          .append('RBP', 'ALL')
      }
    ).pipe(tap(next=>{
      this.data = next.items;
      this.pagination = next.pageInfo;
      this.loadingRef = false;
      this.requestMore = false;
      const helper = this.injector.get(WaHelperService);
      this.data.forEach(value=>{
        helper.addCountryNameItem(new CountryNameItem(value));
      });
    }));

  }
}
